const cardHoverDisabledAttribute = 'data-iicase-disable-card-hover';
const productCardHoverPatchedFlag = '__iicaseProductCardHoverPatched';
const productCardInstancePatchedFlag = '__iicaseProductCardInstancePatched';
const collectionPhoneFilterSelector = '[data-iicase-collection-phone-filter]';
const collectionPhoneFilterMapSelector = '[data-iicase-card-phone-filter-map]';
const collectionCardPhoneFilterGallerySelector = '[data-iicase-card-phone-filter-carousel]';
const collectionCardGalleryVisibleClass = 'is-iicase-card-gallery-in-view';
const collectionCardDeferredImageSelector = '[data-iicase-card-phone-filter-deferred]';
const collectionCardDeferredVariantSelector = '[data-iicase-card-variant-deferred]';
const collectionPhoneFilterMapSectionId = 'iicase-card-phone-filter-media';
const collectionCaseColorPriorityMapSelector = '[data-iicase-collection-case-color-priority-map]';
const collectionPhoneFilterImageWidths = [352, 533, 750, 1000, 1200];
const productPhoneFilterImageWidths = [352, 533, 750, 1000, 1200, 1600, 1800];
const collectionCaseColorPriorityMapFallback =
  'silver: silver, clear, clear-white, white, natural-titanium, starlight; ' +
  'blue: blue, s-blue, ice-blue, frost-ice-blue, dark-blue, navy; ' +
  'purple: purple, plum, dark-plum, deep-purple; ' +
  'orange: orange, cosmic-orange; ' +
  'pink: pink, rose, rose-gold; ' +
  'black: black, space-black, graphite; ' +
  'green: green, alpine-green; ' +
  'gold: gold';
let selectedCollectionPhoneColor = '';
let selectedCollectionPhoneLabel = 'Unselected';
let selectedCollectionPhoneSwatch = '#d7d7d2';
let collectionPhoneFilterMutationObserver = null;
let collectionCardGalleryIntersectionObserver = null;
let collectionCardGalleryPositionFrame = 0;
let collectionCardGalleryPositionListenersStarted = false;
const collectionCardGalleriesInViewport = new Set();
const collectionPhoneFilterMapRequests = new Map();
let collectionCaseColorPriorityMapCache = null;
let collectionCaseColorPriorityMapCacheSource = '';

function iicaseHandleize(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function getUniqueHandles(values) {
  const handles = [];

  values.forEach((value) => {
    const handle = iicaseHandleize(value);
    if (handle && !handles.includes(handle)) handles.push(handle);
  });

  return handles;
}

function parseCollectionCaseColorPriorityMap(value) {
  const map = new Map();
  const rows = String(value || '')
    .replace(/\\n/g, '\n')
    .split(/[\r\n;]+/);

  rows.forEach((row) => {
    const match = row.trim().match(/^(.*?)\s*(?::|=>|=)\s*(.*?)$/);
    if (!match) return;

    const phoneHandles = getUniqueHandles(match[1].split(/[|/]/));
    const caseHandles = getUniqueHandles(match[2].split(/[,|/]/));
    if (!phoneHandles.length || !caseHandles.length) return;

    phoneHandles.forEach((phoneHandle) => {
      const existingHandles = map.get(phoneHandle) || [];
      map.set(phoneHandle, getUniqueHandles([...existingHandles, ...caseHandles]));
    });
  });

  return map;
}

function getCollectionCaseColorPriorityMap() {
  const script = document.querySelector(collectionCaseColorPriorityMapSelector);
  const scriptSource = script?.textContent?.trim() || '';
  let source = collectionCaseColorPriorityMapFallback;

  if (scriptSource) {
    try {
      source = String(JSON.parse(scriptSource) || '');
    } catch (error) {
      source = scriptSource;
    }
  }

  if (collectionCaseColorPriorityMapCache && collectionCaseColorPriorityMapCacheSource === source) {
    return collectionCaseColorPriorityMapCache;
  }

  collectionCaseColorPriorityMapCacheSource = source;
  collectionCaseColorPriorityMapCache = parseCollectionCaseColorPriorityMap(source);
  return collectionCaseColorPriorityMapCache;
}

function getCollectionCaseColorCandidatesForSelectedPhone() {
  const priorityMap = getCollectionCaseColorPriorityMap();
  const phoneHandles = getUniqueHandles([selectedCollectionPhoneColor, selectedCollectionPhoneLabel]);
  const candidates = [];

  phoneHandles.forEach((phoneHandle) => {
    candidates.push(...(priorityMap.get(phoneHandle) || []));
  });

  candidates.push(...phoneHandles);
  return getUniqueHandles(candidates);
}


function lockProductCardAfterSwatchSelection(target) {
  if (!(target instanceof HTMLInputElement) || !target.checked) return;
  if (!target.closest('swatches-variant-picker-component')) return;

  const productCard = target.closest('product-card');
  hydrateProductCardVariantMedia(productCard, target.dataset.optionMediaId || '');
  productCard?.setAttribute(cardHoverDisabledAttribute, 'true');
}

function getSwatchInputForPreview(productCard, mediaId, event) {
  const eventTarget = event?.target;
  if (eventTarget instanceof Element) {
    const hoveredInput = eventTarget.closest('label')?.querySelector('input[type="radio"]');
    if (hoveredInput instanceof HTMLInputElement) return hoveredInput;
  }

  return (
    Array.from(productCard.querySelectorAll('swatches-variant-picker-component input[type="radio"]')).find(
      (input) => input instanceof HTMLInputElement && input.dataset.optionMediaId === String(mediaId)
    ) || null
  );
}

function rememberCollectionPhoneOriginalImage(image) {
  if ('iicaseCollectionPhoneOriginalSrc' in image.dataset) return;

  image.dataset.iicaseCollectionPhoneOriginalSrc = image.getAttribute('src') || '';
  image.dataset.iicaseCollectionPhoneOriginalSrcset = image.getAttribute('srcset') || '';
  image.dataset.iicaseCollectionPhoneOriginalSizes = image.getAttribute('sizes') || '';
  image.dataset.iicaseCollectionPhoneOriginalAlt = image.getAttribute('alt') || '';
  image.dataset.iicaseCollectionPhoneOriginalMaxResolution =
    image.getAttribute('data-max-resolution') || image.getAttribute('data_max_resolution') || '';
}

function restoreCollectionPhoneImage(image) {
  if (!('iicaseCollectionPhoneOriginalSrc' in image.dataset)) return;

  const originalSrc = image.dataset.iicaseCollectionPhoneOriginalSrc;
  const originalSrcset = image.dataset.iicaseCollectionPhoneOriginalSrcset;
  const originalSizes = image.dataset.iicaseCollectionPhoneOriginalSizes;
  const originalAlt = image.dataset.iicaseCollectionPhoneOriginalAlt;
  const originalMaxResolution = image.dataset.iicaseCollectionPhoneOriginalMaxResolution;

  if (originalSizes) {
    image.setAttribute('sizes', originalSizes);
  } else {
    image.removeAttribute('sizes');
  }

  if (originalSrcset) {
    image.setAttribute('srcset', originalSrcset);
  } else {
    image.removeAttribute('srcset');
  }

  if (originalSrc) image.setAttribute('src', originalSrc);
  image.setAttribute('alt', originalAlt || '');

  if (originalMaxResolution) {
    image.setAttribute('data-max-resolution', originalMaxResolution);
    image.setAttribute('data_max_resolution', originalMaxResolution);
  } else {
    image.removeAttribute('data-max-resolution');
    image.removeAttribute('data_max_resolution');
  }

  delete image.dataset.iicaseCollectionPhoneFilterApplied;
}

function getIicaseImageUrlAtWidth(source, width) {
  if (!source || !width) return source || '';

  try {
    const url = new URL(source, window.location.href);
    url.searchParams.set('width', String(width));
    return url.href;
  } catch (error) {
    return source;
  }
}

function getIicaseImageSourceKey(source) {
  if (!source) return '';

  try {
    const url = new URL(source, window.location.href);
    url.searchParams.delete('width');
    return url.toString();
  } catch (error) {
    return source;
  }
}

function doesIicaseImageMatchEntry(image, entry) {
  if (!(image instanceof HTMLImageElement) || !entry) return false;

  const imageSource = image.currentSrc || image.getAttribute('src') || '';
  const entrySource = entry.src || entry.baseSrc || '';
  return getIicaseImageSourceKey(imageSource) === getIicaseImageSourceKey(entrySource);
}

function expandIicasePhoneFilterMapEntry(entry, mapScript) {
  if (!entry?.baseSrc) return entry;

  const context = mapScript.dataset.iicasePhoneFilterMapContext || 'card';
  const isProductMap = context === 'product';
  const widths = isProductMap ? productPhoneFilterImageWidths : collectionPhoneFilterImageWidths;
  const defaultWidth = Number(mapScript.dataset.iicasePhoneFilterMapSrcWidth) || (isProductMap ? 1200 : 750);
  const sizes =
    mapScript.dataset.iicasePhoneFilterMapSizes || (isProductMap ? '(min-width: 750px) 50vw, 100vw' : '50vw');

  return {
    ...entry,
    fullSrc: isProductMap ? getIicaseImageUrlAtWidth(entry.baseSrc, 3840) : '',
    sizes,
    src: getIicaseImageUrlAtWidth(entry.baseSrc, defaultWidth),
    srcset: widths.map((width) => `${getIicaseImageUrlAtWidth(entry.baseSrc, width)} ${width}w`).join(', '),
  };
}

function parseIicasePhoneFilterMediaMap(mapScript) {
  if (!(mapScript instanceof HTMLScriptElement)) return [];

  const mapSource = mapScript?.textContent?.trim() || '';
  let map = [];

  if (mapSource) {
    try {
      const parsedMap = JSON.parse(mapSource);
      if (Array.isArray(parsedMap)) {
        map = parsedMap
          .map((entry) => expandIicasePhoneFilterMapEntry(entry, mapScript))
          .filter(
            (entry) =>
              entry?.src && (entry.type === 'all-colors' || (entry?.case && entry?.phone))
          );
      }
    } catch (error) {
      map = [];
    }
  }

  return map;
}

function getIicasePhoneFilterMediaMap(root, cacheKey) {
  if (!(root instanceof Element)) return [];

  const mapScript = root.querySelector(collectionPhoneFilterMapSelector);
  const mapSource = mapScript?.textContent?.trim() || '';
  const cachedMap = root[cacheKey];

  if (cachedMap?.source === mapSource && Array.isArray(cachedMap.map)) {
    return cachedMap.map;
  }

  const map = parseIicasePhoneFilterMediaMap(mapScript);

  Object.defineProperty(root, cacheKey, {
    value: { map, source: mapSource },
    writable: true,
    configurable: true,
  });

  return map;
}

function getCollectionPhoneFilterMap(productCard) {
  return getIicasePhoneFilterMediaMap(productCard, '__iicaseCollectionPhoneFilterMap');
}

function isCollectionPhoneFilterMapDeferred(productCard) {
  const mapScript = productCard?.querySelector?.(collectionPhoneFilterMapSelector);
  return mapScript?.dataset.iicasePhoneFilterMapDeferred === 'true';
}

function getCollectionPhoneFilterMapRequestUrl(productCard) {
  const link = productCard?.refs?.productCardLink || productCard?.querySelector?.('a[ref="productCardLink"]');
  if (!(link instanceof HTMLAnchorElement) || !link.href) return '';

  const url = new URL(link.href, window.location.origin);
  url.search = '';
  url.hash = '';
  url.searchParams.set('section_id', collectionPhoneFilterMapSectionId);
  return url.toString();
}

function installCollectionPhoneFilterMap(productCard, payload) {
  const mapScript = productCard?.querySelector?.(collectionPhoneFilterMapSelector);
  if (!(mapScript instanceof HTMLScriptElement) || !payload?.source) return false;

  mapScript.textContent = payload.source;
  Object.entries(payload.dataset || {}).forEach(([key, value]) => {
    mapScript.dataset[key] = value;
  });
  mapScript.dataset.iicasePhoneFilterMapDeferred = 'false';
  delete productCard.__iicaseCollectionPhoneFilterMap;
  return true;
}

function loadCollectionPhoneFilterMap(productCard) {
  if (!(productCard instanceof Element) || !isCollectionPhoneFilterMapDeferred(productCard)) {
    return Promise.resolve(getCollectionPhoneFilterMap(productCard));
  }

  const mapScript = productCard.querySelector(collectionPhoneFilterMapSelector);
  if (mapScript?.dataset.iicasePhoneFilterMapFailed === 'true') {
    return Promise.resolve(getCollectionPhoneFilterMap(productCard));
  }

  const requestUrl = getCollectionPhoneFilterMapRequestUrl(productCard);
  if (!requestUrl) return Promise.resolve(getCollectionPhoneFilterMap(productCard));

  let request = collectionPhoneFilterMapRequests.get(requestUrl);
  if (!request) {
    request = fetch(requestUrl, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Phone filter media request failed: ${response.status}`);
        return response.text();
      })
      .then((htmlText) => {
        const html = new DOMParser().parseFromString(htmlText, 'text/html');
        const responseMapScript = html.querySelector(collectionPhoneFilterMapSelector);
        const source = responseMapScript?.textContent?.trim() || '';
        if (!(responseMapScript instanceof HTMLScriptElement) || !source) {
          throw new Error('Phone filter media response did not contain a map');
        }

        return { source, dataset: { ...responseMapScript.dataset } };
      });
    collectionPhoneFilterMapRequests.set(requestUrl, request);
  }

  return request
    .then((payload) => {
      installCollectionPhoneFilterMap(productCard, payload);
      return getCollectionPhoneFilterMap(productCard);
    })
    .catch((error) => {
      if (mapScript instanceof HTMLScriptElement) mapScript.dataset.iicasePhoneFilterMapFailed = 'true';
      console.warn('[iiCase] Deferred card media could not be loaded.', error);
      return getCollectionPhoneFilterMap(productCard);
    });
}

function isCollectionPhoneFilterCardCarouselEnabled(productCard) {
  const mapScript = productCard.querySelector(collectionPhoneFilterMapSelector);
  return mapScript?.dataset.iicaseProductCardCarouselEnabled === 'true';
}

function getProductCardSlideshow(productCard) {
  if (!(productCard instanceof Element)) return null;

  return (
    productCard.querySelector('[data-iicase-card-gallery] slideshow-component') ||
    productCard.refs?.slideshow ||
    null
  );
}


function getProductCardActiveImage(productCard) {
  const slideshow = getProductCardSlideshow(productCard);
  const currentSlide = slideshow?.slides?.[slideshow?.current];
  const currentImage = currentSlide?.querySelector?.('img.product-media__image');
  if (currentImage instanceof HTMLImageElement) return currentImage;

  const visibleImage = productCard.querySelector(
    'slideshow-slide[aria-hidden="false"]:not([hidden]) img.product-media__image, slideshow-slide:not([hidden]) img.product-media__image'
  );
  if (visibleImage instanceof HTMLImageElement) return visibleImage;

  const fallbackImage = productCard.querySelector('img.product-media__image');
  return fallbackImage instanceof HTMLImageElement ? fallbackImage : null;
}

function getProductCardSlides(productCard) {
  if (!(productCard instanceof Element)) return [];

  const slideshow = getProductCardSlideshow(productCard);
  const refSlides = slideshow?.refs?.slides;
  if (refSlides) {
    return Array.from(refSlides).filter((slide) => slide instanceof Element);
  }

  return Array.from(productCard.querySelectorAll('slideshow-slide'));
}

function getProductCardSlideByMediaId(productCard, mediaId) {
  if (!(productCard instanceof Element) || !mediaId) return null;

  return (
    getProductCardSlides(productCard).find((slide) => slide?.getAttribute?.('slide-id') === String(mediaId)) || null
  );
}

function getProductCardImageByMediaId(productCard, mediaId) {
  const matchingSlide = getProductCardSlideByMediaId(productCard, mediaId);
  const image = matchingSlide?.querySelector?.('img.product-media__image');

  return image instanceof HTMLImageElement ? image : null;
}

function showProductCardMedia(productCard, mediaId) {
  if (!(productCard instanceof Element) || !mediaId) return null;

  const slideshow = getProductCardSlideshow(productCard);
  const slides = getProductCardSlides(productCard);
  const targetSlide = slides.find((slide) => slide?.getAttribute?.('slide-id') === String(mediaId));
  if (!targetSlide) return null;

  const slideshowIsDisabled = slideshow?.getAttribute?.('disabled') === 'true';

  slides.forEach((slide) => {
    const isTarget = slide === targetSlide;
    const isVariantImage = slide.getAttribute('variant-image') != null;
    const variantOwner = slide.getAttribute('data-iicase-card-variant-owner');
    const isInitialMedia = slide.hasAttribute('data-iicase-card-initial-media');

    if (isTarget) {
      slide.hidden = false;
      slide.removeAttribute('hidden');
      slide.setAttribute('aria-hidden', 'false');
      return;
    }

    if (slideshowIsDisabled || isVariantImage || isInitialMedia || variantOwner !== String(mediaId)) {
      slide.hidden = true;
      slide.setAttribute('aria-hidden', 'true');
      slide.removeAttribute('reveal');
    } else if (variantOwner === String(mediaId)) {
      hydrateProductCardVariantMedia(productCard, slide.getAttribute('slide-id'));
      slide.hidden = false;
      slide.removeAttribute('hidden');
    }
  });

  slideshow?.select?.({ id: String(mediaId) }, undefined, { animate: false });

  const arrows = slideshow?.querySelector?.('slideshow-arrows');
  if (arrows) arrows.hidden = slideshowIsDisabled || slides.filter((slide) => !slide.hidden).length <= 1;

  const image = targetSlide.querySelector('img.product-media__image');
  return image instanceof HTMLImageElement ? image : null;
}

function hydrateProductCardVariantMedia(productCard, mediaId) {
  if (!(productCard instanceof Element) || !mediaId) return null;

  const targetSlide = getProductCardSlideByMediaId(productCard, mediaId);
  if (!(targetSlide instanceof HTMLElement)) return null;

  const existingImage = targetSlide.querySelector('img.product-media__image');
  if (existingImage instanceof HTMLImageElement) return existingImage;
  if (!targetSlide.matches(collectionCardDeferredVariantSelector)) return null;

  const baseSrc = targetSlide.dataset.iicaseCardVariantSrc || '';
  const sourceSlide = getProductCardSlides(productCard).find(
    (slide) => slide !== targetSlide && slide.querySelector('img.product-media__image')
  );
  const sourceMedia = sourceSlide?.querySelector?.('.product-media');
  if (!baseSrc || !(sourceMedia instanceof HTMLElement)) return null;

  const media = sourceMedia.cloneNode(true);
  const image = media.querySelector('img.product-media__image');
  if (!(image instanceof HTMLImageElement)) return null;

  const gallery = targetSlide.closest('[data-iicase-card-gallery]');
  const renderedWidth = Math.ceil(gallery?.getBoundingClientRect?.().width || 0);
  const sizes = renderedWidth > 0 ? `${renderedWidth}px` : image.getAttribute('sizes') || '50vw';

  media.dataset.mediaId = String(mediaId);
  image.removeAttribute('data-iicase-collection-phone-filter-applied');
  image.setAttribute('loading', 'eager');
  image.setAttribute('sizes', sizes);
  image.setAttribute('src', getIicaseImageUrlAtWidth(baseSrc, 750));
  image.setAttribute(
    'srcset',
    collectionPhoneFilterImageWidths
      .map((width) => `${getIicaseImageUrlAtWidth(baseSrc, width)} ${width}w`)
      .join(', ')
  );
  image.setAttribute('data-max-resolution', getIicaseImageUrlAtWidth(baseSrc, 3840));
  image.setAttribute('data_max_resolution', getIicaseImageUrlAtWidth(baseSrc, 3840));

  targetSlide.replaceChildren(media);
  targetSlide.removeAttribute('data-iicase-card-variant-deferred');
  targetSlide.removeAttribute('data-iicase-card-variant-src');
  image.decode?.().catch(() => {});
  return image;
}

function getCollectionCaseColorInput(productCard, caseColor) {
  const caseColorHandle = iicaseHandleize(caseColor);
  if (!caseColorHandle) return null;

  return (
    Array.from(productCard.querySelectorAll('input[data-iicase-case-color]')).find((input) => {
      if (!(input instanceof HTMLInputElement)) return false;
      return iicaseHandleize(input.dataset.iicaseCaseColor || input.value) === caseColorHandle;
    }) || null
  );
}

function hasCollectionPhoneFilterEntry(phoneFilterMap, caseColor) {
  const caseColorHandle = iicaseHandleize(caseColor);
  return phoneFilterMap.some(
    (entry) =>
      entry.type !== 'all-colors' &&
      entry.case === caseColorHandle &&
      (selectedCollectionPhoneColor
        ? entry.phone === selectedCollectionPhoneColor || entry.phone === 'all'
        : entry.phone !== 'all')
  );
}

function getCollectionAutoCaseColorInput(productCard, phoneFilterMap) {
  const caseColorCandidates = getCollectionCaseColorCandidatesForSelectedPhone();
  if (!caseColorCandidates.length) return null;

  for (const caseColor of caseColorCandidates) {
    const input = getCollectionCaseColorInput(productCard, caseColor);
    if (!(input instanceof HTMLInputElement)) continue;
    if (input.dataset.hasAvailableVariant === 'false') continue;
    if (!hasCollectionPhoneFilterEntry(phoneFilterMap, caseColor)) continue;

    return input;
  }

  return null;
}

function moveProductCardCaseColorSwatchToFront(input) {
  const swatchItem = input.closest('.variant-option__swatch');
  const overflowList = swatchItem?.closest('overflow-list');
  if (!(swatchItem instanceof HTMLElement) || !(overflowList instanceof HTMLElement)) return;

  Array.from(overflowList.children).forEach((child, index) => {
    if (!(child instanceof HTMLElement) || !child.classList.contains('variant-option__swatch')) return;
    if (!child.dataset.iicaseOriginalSwatchIndex) child.dataset.iicaseOriginalSwatchIndex = String(index);
  });

  const firstSwatchItem = Array.from(overflowList.children).find((child) =>
    child.classList?.contains('variant-option__swatch')
  );

  if (firstSwatchItem === swatchItem) return;

  swatchItem.removeAttribute('slot');
  overflowList.insertBefore(swatchItem, firstSwatchItem || overflowList.firstElementChild);
  overflowList.dispatchEvent(new CustomEvent('reflow', { bubbles: true, detail: {} }));
}

function restoreProductCardCaseColorSwatchOrder(productCard) {
  if (!(productCard instanceof Element)) return;

  productCard.querySelectorAll('swatches-variant-picker-component overflow-list').forEach((overflowList) => {
    if (!(overflowList instanceof HTMLElement)) return;

    const moreItem = Array.from(overflowList.children).find(
      (child) => child instanceof HTMLElement && child.getAttribute('slot') === 'more'
    );
    const swatchItems = Array.from(overflowList.children).filter(
      (child) => child instanceof HTMLElement && child.classList.contains('variant-option__swatch')
    );

    if (swatchItems.length < 2 || swatchItems.some((item) => !item.dataset.iicaseOriginalSwatchIndex)) return;

    swatchItems
      .sort(
        (first, second) =>
          Number(first.dataset.iicaseOriginalSwatchIndex) - Number(second.dataset.iicaseOriginalSwatchIndex)
      )
      .forEach((item) => overflowList.insertBefore(item, moreItem || null));

    overflowList.dispatchEvent(new CustomEvent('reflow', { bubbles: true, detail: {} }));
  });
}

function syncProductCardCaseColorPreview(productCard, input) {
  if (!(productCard instanceof Element) || !(input instanceof HTMLInputElement)) return;

  const caseColor = input.dataset.iicaseCaseColor || iicaseHandleize(input.value);
  const variantId = input.dataset.variantId || input.dataset.firstAvailableOrFirstVariantId || '';
  const mediaId = input.dataset.optionMediaId || '';
  const variantPicker = input.closest('swatches-variant-picker-component');

  if (variantPicker && typeof variantPicker.updateSelectedOption === 'function') {
    try {
      variantPicker.updateSelectedOption(input);
    } catch (error) {
      input.checked = true;
    }
  } else {
    input.checked = true;
  }

  moveProductCardCaseColorSwatchToFront(input);
  productCard.dataset.iicaseCollectionCurrentCaseColor = caseColor;

  if (variantId && typeof productCard.applyVariantToLinks === 'function') {
    productCard.applyVariantToLinks(variantId, input.dataset.connectedProductUrl || undefined);
  }

  if (!mediaId) return;

  hydrateProductCardVariantMedia(productCard, mediaId);
  showProductCardMedia(productCard, mediaId);
}

function getCollectionCaseColorForCard(productCard, preferredCaseColor = '') {
  if (preferredCaseColor) return preferredCaseColor;

  const checkedInput = productCard.querySelector('input[data-iicase-case-color]:checked');
  if (checkedInput instanceof HTMLInputElement && checkedInput.dataset.iicaseCaseColor) {
    return checkedInput.dataset.iicaseCaseColor;
  }

  const currentSlide = productCard.refs?.slideshow?.slides?.[productCard.refs?.slideshow?.current];
  const currentMediaId = currentSlide?.getAttribute?.('slide-id');

  if (currentMediaId) {
    const matchingInput = Array.from(productCard.querySelectorAll('input[data-option-media-id][data-iicase-case-color]')).find(
      (input) => input instanceof HTMLInputElement && input.dataset.optionMediaId === currentMediaId
    );

    if (matchingInput instanceof HTMLInputElement && matchingInput.dataset.iicaseCaseColor) {
      return matchingInput.dataset.iicaseCaseColor;
    }
  }

  if (productCard.dataset.iicaseCollectionCurrentCaseColor) {
    return productCard.dataset.iicaseCollectionCurrentCaseColor;
  }

  const firstInput = productCard.querySelector('input[data-iicase-case-color]');
  return firstInput instanceof HTMLInputElement ? firstInput.dataset.iicaseCaseColor || '' : '';
}

function restoreCollectionPhoneImages(productCard) {
  productCard.querySelectorAll('img[data-iicase-collection-phone-filter-applied="true"]').forEach((image) => {
    if (image instanceof HTMLImageElement) restoreCollectionPhoneImage(image);
  });
}

function applyCollectionPhoneImageToImage(image, entry) {
  rememberCollectionPhoneOriginalImage(image);

  if (entry.sizes) image.setAttribute('sizes', entry.sizes);
  if (entry.srcset) {
    image.setAttribute('srcset', entry.srcset);
  } else {
    image.removeAttribute('srcset');
  }

  image.setAttribute('src', entry.src);
  if (entry.alt) image.setAttribute('alt', entry.alt);

  if (entry.fullSrc) {
    image.setAttribute('data-max-resolution', entry.fullSrc);
    image.setAttribute('data_max_resolution', entry.fullSrc);
  }

  image.dataset.iicaseCollectionPhoneFilterApplied = 'true';
}

function getCollectionPhoneFilterGalleryEntries(phoneFilterMap, caseColor) {
  const caseColorHandle = iicaseHandleize(caseColor);
  const caseEntries = phoneFilterMap.filter(
    (entry) => entry.type !== 'all-colors' && entry.case === caseColorHandle
  );
  const phoneColor =
    selectedCollectionPhoneColor || caseEntries.find((entry) => entry.phone && entry.phone !== 'all')?.phone || '';

  if (!phoneColor) return [];

  const entriesBySlot = new Map();
  caseEntries
    .filter((entry) => entry.phone === 'all')
    .forEach((entry, index) => entriesBySlot.set(Number(entry.slot) || index + 1, entry));
  caseEntries
    .filter((entry) => entry.phone === phoneColor)
    .forEach((entry, index) => entriesBySlot.set(Number(entry.slot) || index + 1, entry));

  const entries = Array.from(entriesBySlot.entries())
    .sort(([firstSlot], [secondSlot]) => firstSlot - secondSlot)
    .map(([, entry]) => entry);
  const allColorsEntry = phoneFilterMap.find((entry) => entry.type === 'all-colors');

  if (allColorsEntry && entries.length > 0 && !entries.some((entry) => entry.baseSrc === allColorsEntry.baseSrc)) {
    entries.push(allColorsEntry);
  }

  return entries;
}

function getProductCardPhoneFilterGalleryState(productCard) {
  if (productCard.__iicasePhoneFilterGalleryState) return productCard.__iicasePhoneFilterGalleryState;

  const slideshow = getProductCardSlideshow(productCard);
  const templateSlide = slideshow?.querySelector('slideshow-slide');
  if (!(slideshow instanceof HTMLElement) || !(templateSlide instanceof HTMLElement)) return null;

  const state = {
    templateSlide: templateSlide.cloneNode(true),
    fallbackSlide: templateSlide.cloneNode(true),
    signature: '',
    pendingSignature: '',
    renderSequence: 0,
  };

  Object.defineProperty(productCard, '__iicasePhoneFilterGalleryState', {
    value: state,
    configurable: true,
  });

  return state;
}

function createProductCardPhoneFilterSlide(templateSlide, entry, index) {
  const slide = templateSlide.cloneNode(true);
  const image = slide.querySelector('img.product-media__image');
  const media = slide.querySelector('.product-media');
  const slideId = `iicase-phone-filter-${index}`;

  slide.removeAttribute('hidden');
  slide.removeAttribute('reveal');
  slide.removeAttribute('variant-image');
  slide.removeAttribute('data-iicase-default-hover-media');
  slide.setAttribute('ref', 'slides[]');
  slide.setAttribute('slide-id', slideId);
  slide.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');
  slide.style.setProperty('--slideshow-timeline', `--slide-${index}`);

  if (media instanceof HTMLElement) media.dataset.mediaId = slideId;
  if (image instanceof HTMLImageElement) {
    image.setAttribute('loading', 'lazy');

    if (index === 0) {
      applyCollectionPhoneImageToImage(image, entry);
    } else {
      image.__iicaseDeferredPhoneFilterEntry = entry;
      image.setAttribute('data-iicase-card-phone-filter-deferred', 'true');
      image.removeAttribute('src');
      image.removeAttribute('srcset');
      image.removeAttribute('data-max-resolution');
      image.removeAttribute('data_max_resolution');
    }
  }

  return slide;
}

function waitForProductCardGalleryImage(image) {
  if (!(image instanceof HTMLImageElement) || (image.complete && image.naturalWidth > 0)) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    let finished = false;
    const finish = () => {
      if (finished) return;
      finished = true;
      image.removeEventListener('load', finish);
      image.removeEventListener('error', finish);
      resolve();
    };

    image.addEventListener('load', finish, { once: true });
    image.addEventListener('error', finish, { once: true });
    if (typeof image.decode === 'function') {
      image.decode().then(finish).catch(() => {
        if (image.complete) finish();
      });
    }
  });
}

function hydrateCollectionCardPhoneFilterImages(gallery) {
  if (!(gallery instanceof Element)) return;

  gallery.querySelectorAll(collectionCardDeferredImageSelector).forEach((image) => {
    if (!(image instanceof HTMLImageElement)) return;

    const entry = image.__iicaseDeferredPhoneFilterEntry;
    if (!entry) return;

    delete image.__iicaseDeferredPhoneFilterEntry;
    image.removeAttribute('data-iicase-card-phone-filter-deferred');
    image.setAttribute('loading', 'eager');
    applyCollectionPhoneImageToImage(image, entry);
    image.decode?.().catch(() => {});
  });
}

function prepareCollectionCardPhoneFilterGallery(gallery) {
  if (!(gallery instanceof Element)) return Promise.resolve();

  const productCard = gallery.closest('product-card');
  if (!(productCard instanceof Element) || !isCollectionPhoneFilterMapDeferred(productCard)) {
    return Promise.resolve();
  }

  return loadCollectionPhoneFilterMap(productCard).then(() => {
    const caseColor = productCard.dataset.iicaseCollectionCurrentCaseColor || '';
    applyCollectionPhoneFilterToProductCard(productCard, caseColor);
  });
}

function hydrateCollectionCardPhoneFilterGallery(gallery) {
  if (!(gallery instanceof Element)) return;

  prepareCollectionCardPhoneFilterGallery(gallery).then(() => {
    hydrateCollectionCardPhoneFilterImages(gallery);
  });
}

function syncCollectionCardPhoneFilterGallerySizes(gallery, width = 0) {
  if (!(gallery instanceof Element)) return;

  const renderedWidth = Math.ceil(width || gallery.getBoundingClientRect().width);
  if (renderedWidth <= 0) return;

  const sizes = `${renderedWidth}px`;
  if (gallery.dataset.iicaseCardImageSizes === sizes) return;

  gallery.dataset.iicaseCardImageSizes = sizes;
  gallery.querySelectorAll('img.product-media__image').forEach((image) => {
    if (!(image instanceof HTMLImageElement)) return;

    image.setAttribute('sizes', sizes);
    if (image.__iicaseDeferredPhoneFilterEntry) {
      image.__iicaseDeferredPhoneFilterEntry = {
        ...image.__iicaseDeferredPhoneFilterEntry,
        sizes,
      };
    }
  });
}

function bindCollectionCardPhoneFilterGalleryLoading(gallery) {
  if (!(gallery instanceof HTMLElement) || gallery.dataset.iicaseDeferredLoadingBound === 'true') return;

  const hydrate = () => hydrateCollectionCardPhoneFilterGallery(gallery);
  gallery.addEventListener('pointerenter', hydrate);
  gallery.addEventListener('pointerdown', hydrate);
  gallery.addEventListener('focusin', hydrate);
  gallery.addEventListener('slideshow:select', hydrate);
  gallery.dataset.iicaseDeferredLoadingBound = 'true';
}

function renderProductCardPhoneFilterGallery(productCard, entries) {
  const slideshow = getProductCardSlideshow(productCard);
  const state = getProductCardPhoneFilterGalleryState(productCard);
  if (!(slideshow instanceof HTMLElement) || !state) return null;

  const currentActiveImage = getProductCardActiveImage(productCard);

  const gallery = slideshow.closest(collectionCardPhoneFilterGallerySelector);
  const renderedWidth = Math.ceil(gallery?.getBoundingClientRect().width || 0);
  const renderedSizes = renderedWidth > 0 ? `${renderedWidth}px` : '';
  const sizedEntries = renderedSizes
    ? entries.map((entry) => ({ ...entry, sizes: renderedSizes }))
    : entries;

  const signature = entries.map((entry) => `${entry.type || 'phone'}:${entry.baseSrc}`).join('|') || 'fallback';
  if (state.signature === signature || state.pendingSignature === signature) return currentActiveImage;

  state.pendingSignature = signature;
  const renderSequence = ++state.renderSequence;

  const replacement = slideshow.cloneNode(true);
  const scroller = replacement.querySelector('slideshow-slides');
  if (!(scroller instanceof HTMLElement)) return null;

  const slides = sizedEntries.length
    ? sizedEntries.map((entry, index) => createProductCardPhoneFilterSlide(state.templateSlide, entry, index))
    : [state.fallbackSlide.cloneNode(true)];
  const currentSlide =
    slideshow.querySelector('slideshow-slide[aria-hidden="false"]') ||
    slideshow.querySelector('slideshow-slide:not([hidden])') ||
    slideshow.querySelector('slideshow-slide');
  const currentImage = currentSlide?.querySelector?.('img.product-media__image');
  const reusableSlideIndex =
    currentSlide instanceof HTMLElement && currentImage instanceof HTMLImageElement
      ? sizedEntries.findIndex((entry) => doesIicaseImageMatchEntry(currentImage, entry))
      : -1;
  const activeSlideIndex = reusableSlideIndex >= 0 ? reusableSlideIndex : 0;

  if (reusableSlideIndex >= 0) {
    const reusableEntry = sizedEntries[reusableSlideIndex];
    const reusableSlide = currentSlide.cloneNode(true);
    const reusableImage = reusableSlide.querySelector('img.product-media__image');
    const reusableMedia = reusableSlide.querySelector('.product-media');

    if (reusableImage instanceof HTMLImageElement) {
      delete reusableImage.__iicaseDeferredPhoneFilterEntry;
      reusableImage.removeAttribute('data-iicase-card-phone-filter-deferred');
      reusableImage.setAttribute('loading', 'lazy');
      applyCollectionPhoneImageToImage(reusableImage, reusableEntry);
    }
    if (reusableMedia instanceof HTMLElement) reusableMedia.dataset.mediaId = `iicase-phone-filter-${reusableSlideIndex}`;
    slides[reusableSlideIndex] = reusableSlide;
  }

  slides.forEach((slide, index) => {
    slide.removeAttribute('hidden');
    slide.removeAttribute('reveal');
    slide.removeAttribute('variant-image');
    slide.setAttribute('ref', 'slides[]');
    slide.setAttribute('slide-id', `iicase-phone-filter-${index}`);
    slide.setAttribute('aria-hidden', index === activeSlideIndex ? 'false' : 'true');
    slide.style.setProperty('--slideshow-timeline', `--slide-${index}`);
  });

  scroller.replaceChildren(...slides);
  replacement.setAttribute('initial-slide', String(activeSlideIndex));
  replacement.style.setProperty(
    '--slideshow-timeline',
    slides.map((_, index) => `--slide-${index}`).join(', ')
  );
  replacement.setAttribute('data-generic-media-size', String(slides.length));
  if (slides.length <= 1) {
    replacement.setAttribute('disabled', 'true');
  } else {
    replacement.removeAttribute('disabled');
  }
  const arrows = replacement.querySelector('slideshow-arrows');
  if (arrows instanceof HTMLElement) arrows.hidden = slides.length <= 1;
  replacement.removeAttribute('actioned');
  replacement.removeAttribute('dragging');
  replacement.removeAttribute('refreshing-timeline');
  replacement.removeAttribute('transitioning');

  const replacementActiveImage = replacement.querySelector(
    'slideshow-slide[aria-hidden="false"] img.product-media__image'
  );
  const galleryBounds = gallery?.getBoundingClientRect?.();
  const galleryIsVisible =
    galleryBounds && galleryBounds.bottom > 0 && galleryBounds.top < window.innerHeight;
  if (galleryIsVisible && replacementActiveImage instanceof HTMLImageElement) {
    replacementActiveImage.setAttribute('loading', 'eager');
  }

  const replacementReady = galleryIsVisible
    ? waitForProductCardGalleryImage(replacementActiveImage)
    : Promise.resolve();

  replacementReady.then(() => {
    if (!slideshow.isConnected || state.renderSequence !== renderSequence || state.pendingSignature !== signature) {
      return;
    }

    state.signature = signature;
    state.pendingSignature = '';
    slideshow.replaceWith(replacement);

    if (gallery instanceof HTMLElement) {
      bindCollectionCardPhoneFilterGalleryLoading(gallery);
      delete gallery.dataset.iicaseCardImageSizes;
      syncCollectionCardPhoneFilterGallerySizes(gallery, renderedWidth);
      if (gallery.classList.contains(collectionCardGalleryVisibleClass) || gallery.matches(':hover')) {
        hydrateCollectionCardPhoneFilterGallery(gallery);
      }
    }
  });

  return currentActiveImage;
}

function applyCollectionPhoneFilterToProductCard(productCard, preferredCaseColor = '', options = {}) {
  if (!(productCard instanceof Element)) return;

  const phoneFilterMap = getCollectionPhoneFilterMap(productCard);

  if (phoneFilterMap.length > 0 && isCollectionPhoneFilterCardCarouselEnabled(productCard)) {
    if (!selectedCollectionPhoneColor && !preferredCaseColor) {
      delete productCard.dataset.iicaseCollectionCurrentCaseColor;
      restoreProductCardCaseColorSwatchOrder(productCard);
    }

    const shouldAutoSelectCaseColor =
      selectedCollectionPhoneColor && options.autoSelectCaseColor === true && !preferredCaseColor;
    const autoCaseColorInput = shouldAutoSelectCaseColor
      ? getCollectionAutoCaseColorInput(productCard, phoneFilterMap)
      : null;
    if (autoCaseColorInput instanceof HTMLInputElement) syncProductCardCaseColorPreview(productCard, autoCaseColorInput);

    let caseColor = autoCaseColorInput?.dataset.iicaseCaseColor || getCollectionCaseColorForCard(productCard, preferredCaseColor);
    const hasSelectedCaseEntry = hasCollectionPhoneFilterEntry(phoneFilterMap, caseColor);
    const hasDefaultCaseEntry = hasCollectionPhoneFilterEntry(phoneFilterMap, 'default');

    if ((!caseColor || !hasSelectedCaseEntry) && hasDefaultCaseEntry) caseColor = 'default';

    const galleryEntries = caseColor
      ? getCollectionPhoneFilterGalleryEntries(phoneFilterMap, caseColor)
      : [];
    if (caseColor && galleryEntries.length > 0) {
      productCard.dataset.iicaseCollectionCurrentCaseColor = caseColor;
    }

    renderProductCardPhoneFilterGallery(productCard, galleryEntries);
    return;
  }

  restoreCollectionPhoneImages(productCard);

  if (!selectedCollectionPhoneColor) {
    if (!preferredCaseColor) {
      delete productCard.dataset.iicaseCollectionCurrentCaseColor;
      restoreProductCardCaseColorSwatchOrder(productCard);
    }

    if (preferredCaseColor) {
      const preferredInput = getCollectionCaseColorInput(productCard, preferredCaseColor);
      if (preferredInput instanceof HTMLInputElement) showProductCardMedia(productCard, preferredInput.dataset.optionMediaId || '');
    }
    return;
  }

  const shouldAutoSelectCaseColor = options.autoSelectCaseColor === true && !preferredCaseColor;
  const autoCaseColorInput = shouldAutoSelectCaseColor ? getCollectionAutoCaseColorInput(productCard, phoneFilterMap) : null;
  if (autoCaseColorInput instanceof HTMLInputElement) syncProductCardCaseColorPreview(productCard, autoCaseColorInput);

  let caseColor = autoCaseColorInput?.dataset.iicaseCaseColor || getCollectionCaseColorForCard(productCard, preferredCaseColor);
  const hasSelectedCaseEntry = hasCollectionPhoneFilterEntry(phoneFilterMap, caseColor);
  const hasDefaultCaseEntry = hasCollectionPhoneFilterEntry(phoneFilterMap, 'default');

  if ((!caseColor || !hasSelectedCaseEntry) && hasDefaultCaseEntry) caseColor = 'default';
  if (!caseColor) return;

  const mediaId = autoCaseColorInput?.dataset.optionMediaId || getCollectionCaseColorInput(productCard, caseColor)?.dataset.optionMediaId || '';
  const activeImage = showProductCardMedia(productCard, mediaId) || getProductCardActiveImage(productCard);

  if (phoneFilterMap.length === 0) return;

  const phoneFilterEntry = phoneFilterMap.find(
    (entry) => entry.phone === selectedCollectionPhoneColor && entry.case === caseColor
  );
  if (!phoneFilterEntry) return;

  if (!activeImage) return;

  productCard.dataset.iicaseCollectionCurrentCaseColor = caseColor;
  applyCollectionPhoneImageToImage(activeImage, phoneFilterEntry);
}

function applyCollectionPhoneFilterToCards(root = document, options = {}) {
  const productCards =
    root instanceof Element && root.matches('product-card')
      ? [root]
      : Array.from(root.querySelectorAll?.('product-card') || []);

  productCards.forEach((productCard) =>
    applyCollectionPhoneFilterToProductCard(productCard, '', {
      autoSelectCaseColor: options.autoSelectCaseColor ?? true,
    })
  );
}

function updateCollectionCardGalleryVisibility() {
  collectionCardGalleryPositionFrame = 0;
  const viewportCenter = window.innerHeight / 2;
  const centerEnterTolerance = window.innerHeight * 0.2;
  const centerExitTolerance = window.innerHeight * 0.28;

  collectionCardGalleriesInViewport.forEach((gallery) => {
    if (!gallery.isConnected) {
      collectionCardGalleriesInViewport.delete(gallery);
      return;
    }

    const bounds = gallery.getBoundingClientRect();
    const galleryCenter = bounds.top + bounds.height / 2;
    const wasInCenterBand = gallery.classList.contains(collectionCardGalleryVisibleClass);
    const centerTolerance = wasInCenterBand ? centerExitTolerance : centerEnterTolerance;
    const isInCenterBand = Math.abs(galleryCenter - viewportCenter) <= centerTolerance;
    syncCollectionCardPhoneFilterGallerySizes(gallery, bounds.width);
    gallery.classList.toggle(collectionCardGalleryVisibleClass, isInCenterBand);

    if (isInCenterBand) hydrateCollectionCardPhoneFilterGallery(gallery);
  });
}

function scheduleCollectionCardGalleryVisibilityUpdate() {
  if (collectionCardGalleryPositionFrame) return;
  collectionCardGalleryPositionFrame = window.requestAnimationFrame(updateCollectionCardGalleryVisibility);
}

function observeCollectionCardGalleryVisibility(root = document) {
  const galleries =
    root instanceof Element && root.matches(collectionCardPhoneFilterGallerySelector)
      ? [root]
      : Array.from(root.querySelectorAll?.(collectionCardPhoneFilterGallerySelector) || []);

  if (galleries.length === 0) return;

  if (!('IntersectionObserver' in window)) {
    galleries.forEach((gallery) => collectionCardGalleriesInViewport.add(gallery));
  } else {
    if (!collectionCardGalleryIntersectionObserver) {
      collectionCardGalleryIntersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            collectionCardGalleriesInViewport.add(entry.target);
            prepareCollectionCardPhoneFilterGallery(entry.target);
          } else {
            collectionCardGalleriesInViewport.delete(entry.target);
            entry.target.classList.remove(collectionCardGalleryVisibleClass);
          }
        });

        scheduleCollectionCardGalleryVisibilityUpdate();
      }, {
        root: null,
        rootMargin: '100% 0px',
      });
    }

    galleries.forEach((gallery) => collectionCardGalleryIntersectionObserver.observe(gallery));
  }

  if (!collectionCardGalleryPositionListenersStarted) {
    collectionCardGalleryPositionListenersStarted = true;
    window.addEventListener('scroll', scheduleCollectionCardGalleryVisibilityUpdate, { passive: true });
    window.addEventListener('resize', scheduleCollectionCardGalleryVisibilityUpdate, { passive: true });
  }

  scheduleCollectionCardGalleryVisibilityUpdate();
}

function syncCollectionPhoneFilterAfterSwatchChange(target) {
  if (!(target instanceof HTMLInputElement) || !target.matches('input[data-iicase-case-color]')) return;

  const productCard = target.closest('product-card');
  if (!productCard) return;

  productCard.dataset.iicaseCollectionCurrentCaseColor = target.dataset.iicaseCaseColor || '';

  window.requestAnimationFrame(() => {
    applyCollectionPhoneFilterToProductCard(productCard, productCard.dataset.iicaseCollectionCurrentCaseColor || '');
  });
}

function closeCollectionPhoneFilter(filter) {
  const menu = filter.querySelector('[data-iicase-collection-phone-filter-menu]');
  const toggle = filter.querySelector('[data-iicase-collection-phone-filter-toggle]');

  if (menu) menu.hidden = true;
  if (toggle) toggle.setAttribute('aria-expanded', 'false');
  filter.classList.remove('is-open');
}

function closeOtherCollectionPhoneFilters(currentFilter = null) {
  document.querySelectorAll(collectionPhoneFilterSelector).forEach((filter) => {
    if (filter !== currentFilter) closeCollectionPhoneFilter(filter);
  });
}

function scrollSelectedCollectionPhoneOption(filter) {
  const selectedOption = filter.querySelector('[data-iicase-collection-phone-filter-option].is-selected');
  selectedOption?.scrollIntoView({ block: 'nearest' });
}

function openCollectionPhoneFilter(filter) {
  const menu = filter.querySelector('[data-iicase-collection-phone-filter-menu]');
  const toggle = filter.querySelector('[data-iicase-collection-phone-filter-toggle]');
  if (!menu || !toggle) return;

  closeOtherCollectionPhoneFilters(filter);
  if (typeof closeOtherCollectionModelNavs === 'function') closeOtherCollectionModelNavs();

  menu.hidden = false;
  toggle.setAttribute('aria-expanded', 'true');
  filter.classList.add('is-open');

  window.requestAnimationFrame(() => scrollSelectedCollectionPhoneOption(filter));
}

function toggleCollectionPhoneFilter(filter) {
  const menu = filter.querySelector('[data-iicase-collection-phone-filter-menu]');
  if (!menu) return;

  if (menu.hidden) {
    openCollectionPhoneFilter(filter);
    return;
  }

  closeCollectionPhoneFilter(filter);
}

function syncCollectionPhoneFilterControls() {
  document.querySelectorAll(collectionPhoneFilterSelector).forEach((filter) => {
    const currentLabel = filter.querySelector('[data-iicase-collection-phone-filter-current]');
    if (currentLabel) currentLabel.textContent = selectedCollectionPhoneLabel;

    const toggle = filter.querySelector('[data-iicase-collection-phone-filter-toggle]');
    if (toggle instanceof HTMLElement) {
      toggle.style.setProperty('--iicase-collection-phone-filter-swatch', selectedCollectionPhoneSwatch);
    }

    filter.querySelectorAll('[data-iicase-collection-phone-filter-option]').forEach((option) => {
      const isSelected = option.getAttribute('data-phone-color') === selectedCollectionPhoneColor;
      option.classList.toggle('is-selected', isSelected);
      option.setAttribute('aria-pressed', String(isSelected));
    });

    closeCollectionPhoneFilter(filter);
  });
}

function setSelectedCollectionPhoneFilterOption(option) {
  selectedCollectionPhoneColor = option.getAttribute('data-phone-color') || '';
  selectedCollectionPhoneLabel = option.getAttribute('data-phone-color-label') || option.textContent?.trim() || 'Unselected';
  selectedCollectionPhoneSwatch =
    option.style.getPropertyValue('--iicase-collection-phone-filter-swatch') || '#d7d7d2';
}

function selectCollectionPhoneFilterOption(option) {
  setSelectedCollectionPhoneFilterOption(option);
  syncCollectionPhoneFilterControls();
  applyCollectionPhoneFilterToCards();
}

function initializeCollectionPhoneFilterSelection() {
  const initialOption =
    document.querySelector(`${collectionPhoneFilterSelector} [data-iicase-collection-phone-filter-option].is-selected`) ||
    document.querySelector(`${collectionPhoneFilterSelector} [data-iicase-collection-phone-filter-option]`);

  if (!(initialOption instanceof HTMLElement)) return;

  setSelectedCollectionPhoneFilterOption(initialOption);
  syncCollectionPhoneFilterControls();

  applyCollectionPhoneFilterToCards();
}

function focusCollectionPhoneOption(filter, direction) {
  const options = Array.from(filter.querySelectorAll('[data-iicase-collection-phone-filter-option]')).filter(
    (option) => option instanceof HTMLButtonElement
  );

  if (options.length === 0) return;

  const activeIndex = options.indexOf(document.activeElement);
  let nextIndex = activeIndex;

  if (nextIndex === -1) {
    nextIndex = options.findIndex((option) => option.classList.contains('is-selected'));
  } else {
    nextIndex = (nextIndex + direction + options.length) % options.length;
  }

  if (nextIndex === -1) {
    nextIndex = direction > 0 ? 0 : options.length - 1;
  }

  const nextOption = options[nextIndex];
  nextOption.focus({ preventScroll: true });
  nextOption.scrollIntoView({ block: 'nearest' });
}

function startCollectionPhoneFilterObserver() {
  if (collectionPhoneFilterMutationObserver) return;

  collectionPhoneFilterMutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;

        if (node.matches(collectionPhoneFilterSelector) || node.querySelector(collectionPhoneFilterSelector)) {
          syncCollectionPhoneFilterControls();
        }

        applyCollectionPhoneFilterToCards(node);
        observeCollectionCardGalleryVisibility(node);
      });
    });
  });

  collectionPhoneFilterMutationObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function lockProductCardToHoveredSwatch(productCard, mediaId, event) {
  const input = getSwatchInputForPreview(productCard, mediaId, event);
  if (!(input instanceof HTMLInputElement)) return;
  if (!input.closest('swatches-variant-picker-component')) return;

  productCard.dataset.iicaseCollectionCurrentCaseColor = input.dataset.iicaseCaseColor || '';
  productCard.setAttribute(cardHoverDisabledAttribute, 'true');

  if (!input.checked) {
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

function patchProductCardInstance(productCard) {
  if (productCard[productCardInstancePatchedFlag]) return;

  const resetVariant = productCard.resetVariant;
  if (typeof resetVariant === 'function') {
    const patchedResetVariant = function iicaseResetVariant(...args) {
      if (this.hasAttribute?.(cardHoverDisabledAttribute)) return;

      const result = resetVariant.apply(this, args);
      window.requestAnimationFrame(() => applyCollectionPhoneFilterToProductCard(this));
      return result;
    };

    if (typeof resetVariant.cancel === 'function') {
      patchedResetVariant.cancel = resetVariant.cancel.bind(resetVariant);
    }

    productCard.resetVariant = patchedResetVariant;
  }

  Object.defineProperty(productCard, productCardInstancePatchedFlag, {
    value: true,
    configurable: true,
  });
}

function patchProductCardHover() {
  customElements
    .whenDefined('product-card')
    .then(() => {
      const ProductCard = customElements.get('product-card');
      const prototype = ProductCard?.prototype;
      if (!prototype || prototype[productCardHoverPatchedFlag]) return;

      const connectedCallback = prototype.connectedCallback;
      const previewImage = prototype.previewImage;
      const resetImage = prototype.resetImage;
      const previewVariant = prototype.previewVariant;

      if (typeof connectedCallback === 'function') {
        prototype.connectedCallback = function iicaseProductCardConnectedCallback(...args) {
          const result = connectedCallback.apply(this, args);
          patchProductCardInstance(this);
          return result;
        };
      }

      if (typeof previewImage === 'function') {
        prototype.previewImage = function iicasePreviewImage(event) {
          if (this.hasAttribute?.(cardHoverDisabledAttribute)) return;

          const result = previewImage.call(this, event);
          window.requestAnimationFrame(() => applyCollectionPhoneFilterToProductCard(this));
          return result;
        };
      }

      if (typeof resetImage === 'function') {
        prototype.resetImage = function iicaseResetImage(event) {
          if (this.hasAttribute?.(cardHoverDisabledAttribute)) return;

          const result = resetImage.call(this, event);
          window.requestAnimationFrame(() => applyCollectionPhoneFilterToProductCard(this));
          return result;
        };
      }

      if (typeof previewVariant === 'function') {
        prototype.previewVariant = function iicasePreviewVariant(id, event) {
          const previewInput = getSwatchInputForPreview(this, id, event);
          const caseColor = previewInput?.dataset.iicaseCaseColor || '';
          hydrateProductCardVariantMedia(this, id);
          lockProductCardToHoveredSwatch(this, id, event);
          const result = previewVariant.call(this, id);
          window.requestAnimationFrame(() => applyCollectionPhoneFilterToProductCard(this, caseColor));
          return result;
        };
      }

      Object.defineProperty(prototype, productCardHoverPatchedFlag, {
        value: true,
        configurable: true,
      });

      document.querySelectorAll('product-card').forEach(patchProductCardInstance);
    })
    .catch(() => {});
}


document.addEventListener('change', (event) => {
  if (!(event.target instanceof HTMLSelectElement || event.target instanceof HTMLInputElement)) return;

  lockProductCardAfterSwatchSelection(event.target);
  syncCollectionPhoneFilterAfterSwatchChange(event.target);
}, true);

patchProductCardHover();

const collectionModelNavSelector = '[data-iicase-collection-model-nav]';
const collectionModelNavMobileMedia = window.matchMedia('(max-width: 749px)');
const collectionModelNavCloseTimers = new WeakMap();

function syncCollectionModelSheetPageState() {
  const hasOpenMobileSheet =
    collectionModelNavMobileMedia.matches && document.querySelector(`${collectionModelNavSelector}.is-open`);
  document.documentElement.classList.toggle('iicase-collection-model-sheet-open', Boolean(hasOpenMobileSheet));
}

function closeCollectionModelNav(nav, { immediate = false, restoreFocus = false } = {}) {
  const menu = nav.querySelector('[data-iicase-collection-model-menu]');
  const toggle = nav.querySelector('[data-iicase-collection-model-toggle]');

  if (toggle) toggle.setAttribute('aria-expanded', 'false');
  nav.classList.remove('is-open');

  if (!(menu instanceof HTMLDialogElement)) {
    syncCollectionModelSheetPageState();
    return;
  }

  window.clearTimeout(collectionModelNavCloseTimers.get(menu));
  menu.classList.remove('is-visible');

  const finishClose = () => {
    if (menu.open) menu.close();
    menu.classList.remove('is-mobile-sheet');
    collectionModelNavCloseTimers.delete(menu);
    syncCollectionModelSheetPageState();
    if (restoreFocus && toggle instanceof HTMLElement) toggle.focus();
  };

  if (!immediate && menu.open && menu.classList.contains('is-mobile-sheet')) {
    collectionModelNavCloseTimers.set(menu, window.setTimeout(finishClose, 220));
    return;
  }

  finishClose();
}

function closeOtherCollectionModelNavs(currentNav = null, options = {}) {
  document.querySelectorAll(collectionModelNavSelector).forEach((nav) => {
    if (nav !== currentNav) closeCollectionModelNav(nav, options);
  });
}

function scrollSelectedCollectionModelOption(nav) {
  const selectedOption = nav.querySelector('[data-iicase-collection-model-option].is-selected');
  selectedOption?.scrollIntoView({ block: 'nearest' });
}

function openCollectionModelNav(nav) {
  const menu = nav.querySelector('[data-iicase-collection-model-menu]');
  const toggle = nav.querySelector('[data-iicase-collection-model-toggle]');
  if (!(menu instanceof HTMLDialogElement) || !toggle) return;

  closeOtherCollectionModelNavs(nav, { immediate: true });
  window.clearTimeout(collectionModelNavCloseTimers.get(menu));
  collectionModelNavCloseTimers.delete(menu);

  const isMobileSheet = collectionModelNavMobileMedia.matches;
  menu.classList.toggle('is-mobile-sheet', isMobileSheet);
  if (!menu.open) {
    if (isMobileSheet) {
      menu.showModal();
    } else {
      menu.show();
    }
  }
  toggle.setAttribute('aria-expanded', 'true');
  nav.classList.add('is-open');
  syncCollectionModelSheetPageState();

  window.requestAnimationFrame(() => {
    if (!nav.classList.contains('is-open')) return;
    menu.classList.add('is-visible');
    scrollSelectedCollectionModelOption(nav);
  });
}

function toggleCollectionModelNav(nav) {
  const menu = nav.querySelector('[data-iicase-collection-model-menu]');
  if (!menu) return;

  if (!nav.classList.contains('is-open')) {
    openCollectionModelNav(nav);
    return;
  }

  closeCollectionModelNav(nav, { restoreFocus: true });
}

function focusCollectionModelOption(nav, direction) {
  const options = Array.from(nav.querySelectorAll('[data-iicase-collection-model-option]')).filter(
    (option) => option instanceof HTMLAnchorElement
  );

  if (options.length === 0) return;

  const activeIndex = options.indexOf(document.activeElement);
  let nextIndex = activeIndex;

  if (nextIndex === -1) {
    nextIndex = options.findIndex((option) => option.classList.contains('is-selected'));
  } else {
    nextIndex = (nextIndex + direction + options.length) % options.length;
  }

  if (nextIndex === -1) {
    nextIndex = direction > 0 ? 0 : options.length - 1;
  }

  const nextOption = options[nextIndex];
  nextOption.focus({ preventScroll: true });
  nextOption.scrollIntoView({ block: 'nearest' });
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const closeButton = event.target.closest('[data-iicase-collection-model-close]');
  if (closeButton) {
    const nav = closeButton.closest(collectionModelNavSelector);
    if (nav) closeCollectionModelNav(nav, { restoreFocus: true });
    return;
  }

  const toggle = event.target.closest('[data-iicase-collection-model-toggle]');
  if (toggle) {
    const nav = toggle.closest(collectionModelNavSelector);
    if (nav) {
      event.preventDefault();
      toggleCollectionModelNav(nav);
    }

    return;
  }

  const menu = event.target.closest('[data-iicase-collection-model-menu]');
  if (
    collectionModelNavMobileMedia.matches &&
    menu instanceof HTMLDialogElement &&
    event.target === menu
  ) {
    const nav = menu.closest(collectionModelNavSelector);
    if (nav) closeCollectionModelNav(nav, { restoreFocus: true });
    return;
  }

  if (event.target.closest(collectionModelNavSelector)) return;

  closeOtherCollectionModelNavs();
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    document.querySelectorAll(`${collectionModelNavSelector}.is-open`).forEach((nav) => {
      event.preventDefault();
      closeCollectionModelNav(nav, { restoreFocus: true });
    });

    return;
  }

  if (!(event.target instanceof Element)) return;

  const nav = event.target.closest(collectionModelNavSelector);
  if (!nav) return;

  if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
    event.preventDefault();
    openCollectionModelNav(nav);
    focusCollectionModelOption(nav, event.key === 'ArrowDown' ? 1 : -1);
  }
});

document.addEventListener(
  'cancel',
  (event) => {
    if (!(event.target instanceof HTMLDialogElement)) return;
    if (!event.target.matches('[data-iicase-collection-model-menu]')) return;

    event.preventDefault();
    const nav = event.target.closest(collectionModelNavSelector);
    if (nav) closeCollectionModelNav(nav, { restoreFocus: true });
  },
  true
);

collectionModelNavMobileMedia.addEventListener?.('change', () => {
  closeOtherCollectionModelNavs(null, { immediate: true });
});

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const phoneFilterToggle = event.target.closest('[data-iicase-collection-phone-filter-toggle]');
  if (phoneFilterToggle) {
    const phoneFilter = phoneFilterToggle.closest(collectionPhoneFilterSelector);
    if (phoneFilter) {
      event.preventDefault();
      toggleCollectionPhoneFilter(phoneFilter);
    }

    return;
  }

  const phoneFilterOption = event.target.closest('[data-iicase-collection-phone-filter-option]');
  if (phoneFilterOption) {
    event.preventDefault();
    selectCollectionPhoneFilterOption(phoneFilterOption);
    return;
  }

  if (event.target.closest(collectionPhoneFilterSelector)) return;

  closeOtherCollectionPhoneFilters();
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    document.querySelectorAll(`${collectionPhoneFilterSelector}.is-open`).forEach((filter) => {
      closeCollectionPhoneFilter(filter);
      filter.querySelector('[data-iicase-collection-phone-filter-toggle]')?.focus();
    });

    return;
  }

  if (!(event.target instanceof Element)) return;

  const phoneFilter = event.target.closest(collectionPhoneFilterSelector);
  if (!phoneFilter) return;

  if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
    event.preventDefault();
    openCollectionPhoneFilter(phoneFilter);
    focusCollectionPhoneOption(phoneFilter, event.key === 'ArrowDown' ? 1 : -1);
  }
});

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      initializeCollectionPhoneFilterSelection();
      startCollectionPhoneFilterObserver();
      observeCollectionCardGalleryVisibility();
    },
    { once: true }
  );
} else {
  initializeCollectionPhoneFilterSelection();
  startCollectionPhoneFilterObserver();
  observeCollectionCardGalleryVisibility();
}
